import { useQuery } from "@tanstack/react-query"
import { getEmployeeReport, getEmployeeVisit, getMonthYearFilter } from "./EmployeeRepo"

interface paramInterface{
action:string,
page?:number,
limit?:number,
search?:string,
sortColumn?:string,
sortOrder?:string,
orgUnitId?:number,
employeeId?:number,
startDate?:number   // YY-MM-DD
endDate?:number,
month?:string 
};



export  const useGetEmployeeLsit =({enable,param}:{enable:boolean,param:paramInterface})=>{
   return useQuery({
    queryKey:['EMPLOYEE_REPORT',param],
    queryFn:()=>getEmployeeReport(param),
    retry:false,
    enabled:enable
   })
}  

export  const useGetEmployeeVisit =({enable,attendanceId }:{enable:boolean,attendanceId:number})=>{
   return useQuery({
    queryKey:['EMPLOYEE_VISIT_REPORT',attendanceId ],
    queryFn:()=>getEmployeeVisit(attendanceId),
    retry:false,
    enabled:enable
   })
}  

export  const useGetMothYearFiler =({enable}:{enable:boolean})=>{
   return useQuery({
    queryKey:['GET_MONTH',],
    queryFn:getMonthYearFilter,
    retry:false,
    enabled:enable
   })
}  